export const moduleConfig = {
    entityKey: 'userProfileAttributes',
}
